import { createStore, combineReducers } from 'redux';

//  Import persist functionality
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { persistStore, persistReducer } from 'redux-persist';
import remarkReducer from './remarkReducer';
import userReducer from './userReducer';


// Define the persist configuration
const persistConfig = {
    key: 'root',
    storage,
};

const rootReducer = combineReducers({
    remark: remarkReducer,
    userdetails: userReducer,

});

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);


//  const store = createStore(rootReducer);

// Create the store with the persisted reducer
const store = createStore(persistedReducer);

// Create a persistor
export const persistor = persistStore(store);

export default store;